/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ModifyJobTagLinkRequest model module.
 * @module model/ModifyJobTagLinkRequest
 * @version V1
 */
class ModifyJobTagLinkRequest {
    /**
     * Constructs a new <code>ModifyJobTagLinkRequest</code>.
     * @alias module:model/ModifyJobTagLinkRequest
     */
    constructor() { 
        
        ModifyJobTagLinkRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ModifyJobTagLinkRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModifyJobTagLinkRequest} obj Optional instance to populate.
     * @return {module:model/ModifyJobTagLinkRequest} The populated <code>ModifyJobTagLinkRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModifyJobTagLinkRequest();

            if (data.hasOwnProperty('update')) {
                obj['update'] = ApiClient.convertToType(data['update'], ['Number']);
            }
            if (data.hasOwnProperty('delete')) {
                obj['delete'] = ApiClient.convertToType(data['delete'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ModifyJobTagLinkRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ModifyJobTagLinkRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['update'])) {
            throw new Error("Expected the field `update` to be an array in the JSON data but got " + data['update']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['delete'])) {
            throw new Error("Expected the field `delete` to be an array in the JSON data but got " + data['delete']);
        }

        return true;
    }


}



/**
 * @member {Array.<Number>} update
 */
ModifyJobTagLinkRequest.prototype['update'] = undefined;

/**
 * @member {Array.<Number>} delete
 */
ModifyJobTagLinkRequest.prototype['delete'] = undefined;






export default ModifyJobTagLinkRequest;

